import { createContext, useContext } from 'react';

// Set around one guest's questions, so their conditional logic reads that guest's answers
// rather than the booker's fields: { values: { [questionId]: field with value }, questions }.
const GuestFieldsContext = createContext(null);

export const GuestFieldsProvider = GuestFieldsContext.Provider;
export const useGuestFields = () => useContext(GuestFieldsContext);
